export enum PieceRateAttendanceGoalType {
    Incentive = 1,
    Penalty = 2,
}
